// 浏览器工具函数
export const detectBrowserIssues = () => {
  const issues: string[] = [];
  
  // 检测Chrome版本
  const userAgent = navigator.userAgent;
  const chromeMatch = userAgent.match(/Chrome\/(\d+)/);
  
  if (chromeMatch) {
    const chromeVersion = parseInt(chromeMatch[1]);
    if (chromeVersion >= 80) {
      issues.push('Chrome正在逐步淘汰第三方Cookie，这可能导致某些功能异常');
    }
  }
  
  // 检测可能的扩展冲突
  if (window.chrome && window.chrome.runtime) {
    issues.push('检测到Chrome扩展，某些扩展可能与页面功能冲突');
  }
  
  return issues;
};

export const showBrowserWarning = () => {
  const issues = detectBrowserIssues();
  
  if (issues.length > 0) {
    console.warn('浏览器兼容性提示:', issues);
    
    // 在开发环境下显示更详细的提示
    if (process.env.NODE_ENV === 'development') {
      console.log(`
🔧 开发者提示：
1. 如果看到 "message channel closed" 错误，这通常由Chrome扩展引起
2. 建议在无痕模式下测试，或禁用所有扩展
3. 第三方Cookie警告是Chrome的正常行为，不影响应用功能
4. 这些错误不会影响应用的正常使用
      `);
    }
  }
};

// 安全的错误报告
export const safeErrorReport = (error: Error, context?: string) => {
  // 过滤掉浏览器扩展相关的错误
  const message = error.message.toLowerCase();
  const isBrowserExtensionError = 
    message.includes('message channel closed') ||
    message.includes('asynchronous response') ||
    message.includes('third-party cookies') ||
    message.includes('chrome-extension://');
  
  if (isBrowserExtensionError) {
    console.warn('忽略浏览器扩展相关错误:', error.message);
    return;
  }
  
  // 报告真正的应用错误
  console.error(`应用错误${context ? ` (${context})` : ''}:`, error);
};